import { render } from "./dottoreData.vue?vue&type=template&id=5f6b0ba8&ts=true"
import script from "./dottoreData.vue?vue&type=script&lang=ts"
export * from "./dottoreData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__